import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createRoot } from 'react-dom/client';

import { Button } from '../../scss/legacy_design_system/js';
import Close from '../../Icons/Close';
import classNames from '../../utils/dom-utils';

const DIALOG_ROOT_KEY = '__dialogRoot';

function createElementReconfirm(properties) {
  let divTarget = document.getElementById('dialog');
  if (!divTarget) {
    document.body.children[0].classList.add('dialog-blur');
    divTarget = document.createElement('div');
    divTarget.id = 'dialog';
    document.body.appendChild(divTarget);
  }

  if (!divTarget[DIALOG_ROOT_KEY]) {
    divTarget[DIALOG_ROOT_KEY] = createRoot(divTarget);
  }

  divTarget[DIALOG_ROOT_KEY].render(<Dialog {...properties} />);
}

function removeElementReconfirm() {
  const target = document.getElementById('dialog');
  if (target) {
    if (target[DIALOG_ROOT_KEY]) {
      target[DIALOG_ROOT_KEY].unmount();
      target[DIALOG_ROOT_KEY] = null;
    }
    target.parentNode.removeChild(target);
  }
}

function addBodyClass() {
  document.body.classList.add('dialog__container__element');
}

function removeBodyClass() {
  document.body.classList.remove('dialog__container__element');
}

export function dialog(properties) {
  addBodyClass();
  createElementReconfirm(properties);
}
export default class Dialog extends Component {
  componentDidMount() {
    document.addEventListener('keydown', this.keyboardClose, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyboardClose, false);
    const { willUnmount } = this.props;
    if (willUnmount) {
      willUnmount();
    }
  }

  handleClickButton = (button) => {
    const { primaryClick, secondaryClick } = this.props;
    if (button === 'primaryClick' && primaryClick != null) {
      primaryClick();
    } else if (button === 'secondaryClick' && secondaryClick != null) {
      secondaryClick();
    }
    this.close();
  };

  handleClickOverlay = (e) => {
    const { closeOnClickOutside = true, onClickOutside } = this.props;
    const isClickOutside = e.target === this.overlay;

    if (closeOnClickOutside && isClickOutside) {
      onClickOutside();
      this.close();
    }
  };

  close = () => {
    const { onClickClose } = this.props;

    removeBodyClass();
    removeElementReconfirm();
    if (onClickClose) {
      onClickClose();
    }
  };

  keyboardClose = (event) => {
    const { closeOnEscape = true, onKeypressEscape } = this.props;
    const isKeyCodeEscape = event.keyCode === 27;

    if (closeOnEscape && isKeyCodeEscape) {
      if (onKeypressEscape) {
        onKeypressEscape(event);
      }
      this.close();
    }
  };

  render() {
    const {
      title,
      message,
      primaryLabel,
      secondaryLabel,
      mode = 'darkmode',
    } = this.props;

    const baseClass = 'dialog__container';

    const rootClass = classNames(baseClass, {
      [`${baseClass}--${mode}`]: mode,
    });

    let closeColor = '#ffffff';

    if (mode == 'lightmode') {
      closeColor = '#36343A';
    }

    return (
    /* eslint-disable-next-line */
      <div
        data-testid="overlay-element"
        className="dialog__overlay"
        ref={(dom) => { this.overlay = dom; }}
        onClick={this.handleClickOverlay}
      >
        <div className={rootClass}>
          <div className="dialog__header">
            <button
              type="button"
              data-testid="close-element"
              aria-label="close button"
              onClick={() => this.close()}
            >
              <Close fill={closeColor} width="17.5" />
            </button>
          </div>
          <div className="dialog__body">
            <div className="dialog__body-title">{title}</div>
            <div className="dialog__body-message">{message}</div>
          </div>
          <div className="dialog__buttons">
            {secondaryLabel && (
            <Button
              size="large"
              variant={
                                    mode == 'darkmode'
                                      ? 'hollow-reverse'
                                      : 'secondary'
                                }
              onClick={() => this.handleClickButton('secondaryClick')}
            >
              <span>{secondaryLabel}</span>
            </Button>
            )}
            <Button
              data-testid="primary"
              size="large"
              variant="accent"
              onClick={() => this.handleClickButton('primaryClick')}
            >
              <span>{primaryLabel}</span>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

Dialog.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  primaryLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
  primaryClick: PropTypes.func,
  secondaryClick: PropTypes.func,
  closeOnClickOutside: PropTypes.bool,
  closeOnEscape: PropTypes.bool,
  willUnmount: PropTypes.func,
  onClickOutside: PropTypes.func,
  onKeypressEscape: PropTypes.func,
  onClickClose: PropTypes.func,
  mode: PropTypes.oneOf(['darkmode', 'lightmode']),
};
